import CalendarHeatmap from 'react-calendar-heatmap';
import ReactTooltip from 'react-tooltip';
import { useMemo, useContext, useState } from 'react';
import { useTheme, Typography } from '@material-ui/core';
import TextractContext from '../../../../contexts/TextractContext';

const { getDaysArray } = require("../../../helpers/date-helpers");

export default function MeterOnlyCalendar({ uam }) {
  const [year, setYear] = useState(2024);
  
  const theme = useTheme();
  const dataStart = uam.calendar_data[0] && new Date(uam.calendar_data[0].date)
  const dataEnd = uam.calendar_data[uam.calendar_data.length - 1] && new Date(uam.calendar_data[uam.calendar_data.length - 1].date)

  console.log("dataStart", dataStart)
  console.log("dataEnd", dataEnd)
  const dates = useMemo(() => ({
    startDate: dataStart || new Date(`${year}-01-01`),
    endDate: dataEnd ? new Date(dataEnd.getTime() + 7 * 24 * 60 * 60 * 1000) : new Date(`${year}-12-31`),
  }), [year]);

  const calendarData = useMemo(() => {
    const uamData = uam.calendar_data || [];
    const eventsByDate = {};
    const noDataEvents = uamData.filter(datum => datum.class === "no-data");
    const events = [...uamData.filter(datum => datum.class !== "no-data")];

    events.forEach(event => {
      const dateKey = event.date.slice(0, 10);
      if (!eventsByDate[dateKey]) {
        eventsByDate[dateKey] = [];
      }
      eventsByDate[dateKey].push(event);
    });

    const updatedEvents = Object.values(eventsByDate).flat();
    return [...noDataEvents, ...updatedEvents];
  }, [uam.calendar_data]);

  return (
    <div style={{ width: "80%", padding: "0px 20px 10px 10px", fill: theme.palette.mode === 'light' ? 'black' : 'white', overflow: 'visible' }}>
      <Typography gutterBottom variant='h2'>Bill Data Coverage</Typography>
      <CalendarHeatmap
        style={{ overflow: 'visible' }}
        startDate={dates.startDate}
        endDate={dates.endDate}
        gutterSize={0}
        values={calendarData}
        showOutOfRangeDays={true}
        tooltipDataAttrs={value => ({
          'data-tip': value.id === "No Data"
            ? `${value.id} - ${value.date.slice(0, 10)}`
            : value.id
              ? `${value.id}: ${value.start_date ? value.start_date.slice(0, 10) : ''} - ${value.end_date ? value.end_date.slice(0, 10) : ''}`
              : `${value.date}`,
        })}
        onClick={value => value.link && window.open(value.link)}
        classForValue={value => !value ? 'color-empty' : value.class}
      />
      <ReactTooltip />
    </div>
  );
}